import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import "../../style/style.css";
import "./biografia.css";

import Navbar from "../../componentes/nav";
import Footer from "../../componentes/folter";

// Fotos da professora Iaura (hospedadas no site)
const fotos = [
  "https://somosconexaosocial.org/site_img/bio_iaura/bio001.jpg",
  "https://somosconexaosocial.org/site_img/bio_iaura/bio002.jpg",
  "https://somosconexaosocial.org/site_img/bio_iaura/bio003.jpg",
];

// PDF da biografia (Google Drive em modo /preview, abre embutido na página)
const pdfUrl =
  "https://drive.google.com/file/d/1d6bUeapCvlFCcTpIKL4PKrJH6bsPqNq-/preview";

// TODO: trocar pelo src do vídeo definitivo quando estiver pronto
// Obs: o YouTube só permite embed no formato /embed/ID (não funciona com watch?v= nem youtu.be/)
const videoUrl =
  "https://www.youtube.com/embed/-eabN_tSE9g";

function BiografiaIaura() {
  return (
    <div className="page-container">
      <Navbar />

      <main className="content-wrap">
        <section className="bio-page">
          <div className="bio-inner">
          <h1 className="bio-titulo">Iaura Lima</h1>
          <p className="bio-subtitulo">
            Uma biografia de quem inspira a transformação social
          </p>
          <div className="bio-divider" />

          <div className="bio-grid">
            {/* Carrossel de fotos */}
            <div className="bio-carrossel">
              <Swiper
                modules={[Navigation, Pagination, Autoplay]}
                spaceBetween={0}
                loop={true}
                grabCursor={true}
                navigation={true}
                pagination={{ clickable: true, dynamicBullets: true }}
                autoplay={{ delay: 4000, disableOnInteraction: false }}
              >
                {fotos.map((foto, index) => (
                  <SwiperSlide key={index}>
                    <div className="bio-foto-slide">
                      <img
                        src={foto}
                        alt={`Professora Iaura Lima - foto ${index + 1}`}
                        loading="lazy"
                      />
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>

            {/* PDF da biografia embutido */}
            <div className="bio-pdf">
              <iframe
                src={pdfUrl}
                title="Biografia da professora Iaura Lima"
                allow="autoplay"
              />
            </div>
          </div>

          {/* Seção de vídeo */}
          <div className="bio-video-section">
            <h2 className="bio-video-titulo">Conheça a ACS</h2>
            <div className="bio-video-wrapper">
              <iframe
                src={videoUrl}
                title="Vídeo - Biografia da professora Iaura Lima"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default BiografiaIaura;
